<template>
  <div>
    <!-- Loading Spinner -->
    <div v-if="loading" class="d-flex justify-content-center align-items-center vh-100">
      <div class="spinner-border" role="status"></div>
    </div>

    <!-- Exam List Card -->
    <div v-else class="container py-5">
      <div class="d-flex justify-content-center" v-if="certificationdetails">
        <div class="card shadow-lg rounded-4 p-2 w-100">
          <div class="card-header bg-white d-flex justify-content-between align-items-center">
            <h4 class="mb-0">Certification</h4>
            <button class="print-btn" @click="printCertificate">
                🖨️ Print Certificate
                </button>
            <button class="btn btn-outline-secondary btn-sm" @click="goBack">Back</button>
          </div>

          <div class="card-body">



<div class="certificate-wrapper">
  <div class="certificate">

    <!-- Header -->
    <div class="cert-header">
      <h2>🎵 Kalapini Sangeet Vidhyalay 🎵</h2>
      <div class="cert-line"></div>
      <h4>Certificate of Achievement</h4>
    </div>

    <!-- Body -->
    <div class="cert-body">
      <p>This is to certify that</p>

      <h3 class="student-name">
        {{ certificationdetails.student_name }}
      </h3>

      <p>has successfully completed the examination</p>

      <h4 class="exam-name">
        {{ certificationdetails.exam_name }}
      </h4>

      <p class="exam-type">
        ({{ certificationdetails.exam_type_name }})
      </p>

      <p class="subject">
        Subject: <strong>{{ certificationdetails.subject_name }}</strong>
      </p>

      <p class="marks">
        Marks Obtained:
        <strong>
          {{ certificationdetails.obtained_marks }} /
          {{ certificationdetails.total_marks }}
        </strong>
      </p>
    </div>

    <!-- Footer -->
    <div class="cert-footer">
      <div>
        <div class="sign-line"></div>
        <span>Instructor</span>
      </div>

      <div>
        <div class="sign-line"></div>
        <span>Director</span>
      </div>
    </div>

    <div class="cert-date">
      Date: {{ new Date().toLocaleDateString() }}
    </div>

  </div>
</div>
           




                <div>
                </div>













          </div>

        </div>
      </div>

        <div v-else>
        <span class="text-center text-danger">*No Certification Found</span>
        </div>

    </div>
  </div>

  
</template>

<script> 
import axios from "@/plugins/axios";  

export default {
  name: 'newsession',
  mounted() { 

    if(this.$route.query.id){
    this.getSessions(this.$route.query.id);
    }else{
         this.getSessions();
    }
  },
  data() {
    return {
      loading: true,
      certificationdetails: [],
      examid:'',
      studentId: this.$route.query.student_id,
    };
  },
  methods: {
    
    goBack() {
      this.$router.go(-1);
    },

    async getSessions(id) {
      this.loading = true;
      this.error = null;
  
      try {
        var self = this;


        axios.post("getadmincertification", { id: id }).then((response) => {

          self.certificationdetails = response.data.certificationdetails;
   

        }).then(() => {
          


        }).catch((err) => {
          console.error(err);
        });
      } catch (err) {
        this.error = err.response?.data?.message || "Request failed. Please try again.";
      } finally {
        this.loading = false;
      }
    }, 

     printCertificate() {
    window.print();
  }






  }
}
</script>

<style scoped>
.card {
  border-radius: 16px;
}
table th {
  font-weight: 600;
}
table td {
  font-size: 15px;
}
@media (max-width: 600px) {
  table td {
    font-size: 13px;
  }
}


/* ===== Wrapper ===== */
.certificate-wrapper {
  display: flex;
  justify-content: center;
  padding: 20px;
  background: #f4f6f8;
}

/* ===== Certificate Card ===== */
.certificate {
  width: 148mm;
  min-height: 210mm;
  background: #ffffff;
  padding: 25px;
  border: 6px double #2c3e50;
  font-family: "Times New Roman", serif;
  box-shadow: 0 10px 25px rgba(0,0,0,0.15);
}

/* ===== Header ===== */
.cert-header {
  text-align: center;
}

.cert-header h2 {
  margin: 0;
  font-size: 22px;
  font-weight: bold;
}

.cert-header h4 {
  margin-top: 8px;
  font-weight: normal;
}

.cert-line {
  width: 60%;
  height: 2px;
  background: #2c3e50;
  margin: 10px auto;
}

/* ===== Body ===== */
.cert-body {
  text-align: center;
  margin-top: 35px;
  font-size: 16px;
}

.student-name {
  margin: 15px 0;
  font-size: 22px;
  text-transform: uppercase;
  letter-spacing: 1px;
}

.exam-name {
  margin: 10px 0;
  font-size: 18px;
}

.exam-type {
  font-style: italic;
  color: #555;
}

.subject,
.marks {
  margin-top: 12px;
}

/* ===== Footer ===== */
.cert-footer {
  display: flex;
  justify-content: space-between;
  margin-top: 60px;
}

.sign-line {
  width: 120px;
  border-top: 1px solid #000;
  margin-bottom: 5px;
}

.cert-footer span {
  font-size: 14px;
}

.cert-date {
  text-align: center;
  margin-top: 25px;
  font-size: 14px;
}

/* ===== Mobile Responsive ===== */
@media (max-width: 768px) {
  .certificate {
    width: 100%;
    min-height: auto;
    padding: 18px;
  }

  .cert-header h2 {
    font-size: 18px;
  }

  .student-name {
    font-size: 18px;
  }

  .cert-body {
    font-size: 14px;
  }

  .cert-footer {
    margin-top: 40px;
  }
}

/* ===== Print ===== */
@media print {
  body {
    background: #fff;
  }

  .certificate-wrapper {
    padding: 0;
  }

  .certificate {
    box-shadow: none;
    border: 4px solid #000;
  }
}

.print-btn {
  background: #2c3e50;
  color: #fff;
  border: none;
  padding: 10px 18px;
  font-size: 14px;
  border-radius: 4px;
  cursor: pointer;
}

.print-btn:hover {
  background: #1a252f;
}

/* ===== PRINT ONLY CERTIFICATE ===== */
@media print {

  /* Hide everything */
  body * {
    visibility: hidden;
  }

  /* Show only certificate */
  .certificate-wrapper,
  .certificate-wrapper * {
    visibility: visible;
  }

  /* Position certificate properly */
  .certificate-wrapper {
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    padding: 0;
    background: white;
  }

  /* Remove card & container look */
  .card,
  .card-header,
  .card-body,
  .container {
    border: none !important;
    box-shadow: none !important;
    padding: 0 !important;
    margin: 0 !important;
  }

  /* Hide buttons */
  .print-btn,
  .btn {
    display: none !important;
  }

  /* Certificate clean print */
  .certificate {
    width: 148mm;
    min-height: 210mm;
    border: 2px solid #000;
    box-shadow: none;
  }
}














</style>
